import { Beer, PackageOpen, Radio, ShoppingBag, Cigarette } from 'lucide-react';
import { BARTER_PRICES, PRODUCTS, formatProductQuantity, inventoryCapacityUsed } from '../../game/constants.js';

const money = (value) => `$${Math.max(0, Number(value || 0)).toLocaleString()}`;

export function V2InventoryWindow({ gameState, actionBusy, actions }) {
  const capacityUsed = inventoryCapacityUsed(gameState.inventory || {});
  const barterRows = Object.entries(gameState.barterInventory || {}).filter(([, count]) => Number(count || 0) > 0);
  const smokes = Number(gameState.streetInventory?.smokes || 0);
  const beer = Number(gameState.streetInventory?.beer || 0);
  const canSellSmokes = gameState.streetPrices?.smokes != null && smokes > 0;

  return <div className="v2-inventory-window">
    <section className="v2-window-summary">
      <div><PackageOpen /><span>CARRYING</span><strong>{capacityUsed.toFixed(1).replace(/\.0$/, '')} / {gameState.capacity}g</strong></div>
      <div><ShoppingBag /><span>CASH</span><strong>{money(gameState.cash)}</strong></div>
    </section>

    <section className="v2-window-section">
      <header><span>PRODUCTS</span><strong>What you have on you</strong></header>
      <div className="v2-inventory-product-grid">{PRODUCTS.map((product) => {
        const held = Number(gameState.inventory?.[product.id] || 0);
        return <article key={product.id} className={held > 0 ? 'held' : 'empty'}><span>{product.name}</span><strong>{formatProductQuantity(product.id, held)}</strong></article>;
      })}</div>
    </section>

    <section className="v2-window-section">
      <header><span>STREET GOODS</span><strong>Loose inventory and consumables</strong></header>
      <div className="v2-street-window-grid">
        <article><Cigarette /><div><span>Smokes</span><strong>{smokes} pack{smokes === 1 ? '' : 's'}</strong>{gameState.streetPrices?.smokes != null && <small>Street quote {money(gameState.streetPrices.smokes)}/pack</small>}</div>{canSellSmokes && <div className="v2-inline-actions"><button disabled={actionBusy} onClick={() => actions.sellSmokes(1)}>SELL 1</button><button disabled={actionBusy} onClick={() => actions.sellSmokes(smokes)}>SELL ALL</button></div>}</article>
        <article><Beer /><div><span>Beer</span><strong>{beer} can{beer === 1 ? '' : 's'}</strong><small>Questionable hydration.</small></div><div className="v2-inline-actions"><button disabled={actionBusy || beer <= 0} onClick={actions.drinkBeer}>DRINK 1</button></div></article>
      </div>
    </section>

    <section className="v2-window-section">
      <header><span>FENCED GOODS</span><strong>Suspiciously acquired household property</strong></header>
      {barterRows.length ? <div className="v2-barter-window-list">{barterRows.map(([key, count]) => <article key={key}><Radio /><div><span>{key.replaceAll('_', ' ')}</span><strong>{count} · est. {money(BARTER_PRICES[key] || 0)} each</strong></div>{gameState.currentLocationId === 'pawn_shop' && <button disabled={actionBusy} onClick={() => actions.sellBarter(key)}>FENCE IT</button>}</article>)}</div> : <p className="v2-window-empty">Nothing especially suspicious in the bag right now.</p>}
    </section>

    <footer className="v2-window-footnote">Inventory actions use the same authoritative game handlers as Stable UI. This window does not maintain a second inventory state.</footer>
  </div>;
}
